module.exports = __webpack_public_path__ + "static/media/avatar_bee.50923955.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_bee.png
// module id = 365
// module chunks = 0